<template>
    <div class="container" :class="['spacing-' + belowSpacing]">
        <div v-if="orientation == 'left'" class="row justify-content-start questionLeft">
            <div class="col-8 col-md-6 questionbox" :class="[ customClass ]">
                <h3>{{ question }}</h3><span></span>
                <!-- <swift-input :id="id" placeholder="TYPE YOUR ANSWER" :type="questionType" :value="value" v-on:questionAnswered="handleAnswer" :required="required" :actuallyRequired="actuallyRequired" :options="options" /> -->
            </div>
            <question-sticker v-if="sticker" :positionX="sticker.positionX" :positionY="sticker.positionY" :bleed="sticker.bleed" :fileName="sticker.fileName" :rotate="sticker.rotate" />
        </div>
        <div v-if="orientation == 'right'" class="row justify-content-end questionRight">
            <div class="col-8 col-md-6 questionbox" :class="[ customClass ]">
                <h3>{{ question }}</h3><span></span>
                <!-- <swift-input :id="id" placeholder="TYPE YOUR ANSWER" :type="questionType" :value="value" v-on:questionAnswered="handleAnswer" :required="required" :actuallyRequired="actuallyRequired" :options="options" /> -->
            </div>
            <question-sticker v-if="sticker" :positionX="sticker.positionX" :positionY="sticker.positionY" :bleed="sticker.bleed" :fileName="sticker.fileName" :rotate="sticker.rotate" />
        </div>
        <div v-if="orientation == 'center'" class="row justify-content-center questionCenter">
            <div class="col-12 col-md-8 questionbox" :class="[ customClass ]">
                <p v-if="questionType == 'checkpoint'" class="checkpoint-text">{{ question }}</p>
                <h3 v-else>{{ question }}</h3><span></span>
                <!-- <swift-input v-if="questionType != 'checkpoint'" :id="id" placeholder="TYPE YOUR ANSWER" :type="questionType" :value="value" v-on:questionAnswered="handleAnswer" :required="required" :actuallyRequired="actuallyRequired" :options="options" /> -->
            </div>
            <question-sticker v-if="sticker" :positionX="sticker.positionX" :positionY="sticker.positionY" :bleed="sticker.bleed" :fileName="sticker.fileName" :rotate="sticker.rotate" />
        </div>
    </div>
</template>

<script>
// import SwiftInput from '@/components/SwiftInput';
import QuestionSticker from '@/components/QuestionSticker';

import { otherQuestions } from "../questionnaire/questions.js";

export default {
    name: 'Question',
    components: {
        // SwiftInput,
        QuestionSticker
    },
    props: {
        question: String,
        options: Array,
        orientation: String,
        questionType: String,
        placeholder: String,
        required: Boolean,
        actuallyRequired: Boolean,
        value: String,
        id: String,
        belowSpacing: String,
        customClass: String,
        sticker: Object
    },
    data: function () {
        return {
            otherQuestions
        }
    },
    methods: {
        handleAnswer: function (event) {
            this.otherQuestions.find(question => question.id == event.id).value = event.value;
            sessionStorage.setItem("otherQuestions", JSON.stringify(this.otherQuestions));
        }
    }
}
</script>

<style lang="scss" scoped>
</style>